import React, { Component } from 'react'
import CardHalfHeight from './../../components/cards/CardHalfHeight'
import { Grid, Row, Col } from 'react-bootstrap'
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton'
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { getAuth } from '../../../core/auth'
import { getConfirmedGroup, confirmedGroupActions } from '../../../core/confirmed-group'
import { getHousingResult, housingResultActions } from '../../../core/housing-result'
import { getMemberRecordById } from '../../../core/groups'

const styles = {

  top2: {
    marginTop: 15
}
}

export class HousingResults extends Component {

  componentWillMount() {
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.loadConfirmedGroup()
      this.props.loadHousingResults(currentUser.groupId)
    }
  }

  componentWillReceiveProps(nextProps) {
    const currentUser = this.props.currentUser
    const nextCurrentUser = nextProps.currentUser
    if (!currentUser.isInConfirmedGroup && (nextCurrentUser.isInConfirmedGroup && nextCurrentUser.groupId)) {
      this.props.loadConfirmedGroup()
      this.props.loadHousingResults(nextCurrentUser.groupId)
    }
  }

  componentWillUnmount() {
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.unloadConfirmedGroup()
      this.props.unloadHousingResults()
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.confirmedGroup !== this.props.confirmedGroup ||
    nextProps.housingResult !== this.props.housingResult
  }

  render() {
    const { housingResult } = this.props
    const { currentUser } = this.props
    const { confirmedGroup} = this.props
    let memberEmailString = ``
    if (confirmedGroup) {
      const groupSize = confirmedGroup.groupSize
      for (let i = 0; i < groupSize; i++) {
        memberEmailString += `${getMemberRecordById(confirmedGroup, i).email} `
      }
    }
    return (
      <div>
        <div className="subheader">
          <h4>Your Housing</h4>
        </div>
        <Grid>
          <Row className="show-grid center">
            <Col lg={8} lgOffset={2} sm={12}>
            <div className="center-text headline">
              <h4>Once housing has been finalized, your housing location and roommate list will show below.</h4>
            </div>
              <CardHalfHeight>
                <div>Your Housing Assignment</div>
                <Table style={styles.top2} className="pad-top pre-wrap">
                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                      <TableHeaderColumn>Building</TableHeaderColumn>
                      <TableHeaderColumn>Room</TableHeaderColumn>
                      <TableHeaderColumn>Roommates</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    <TableRow className="table-full">
                      <TableRowColumn className="table-content">
                        {housingResult ? (housingResult.size > 0 ? housingResult.assignment.get('building') : null): null}
                      </TableRowColumn>
                      <TableRowColumn className="table-content">
                        {housingResult ? (housingResult.size > 0 ? housingResult.assignment.get('unit') : null): null}
                      </TableRowColumn>
                      <TableRowColumn className="table-content">
                        {housingResult ? (housingResult.size > 0 ? memberEmailString : null): null}
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardHalfHeight>
              <span>
                Questions or Concerns?
                <a href="mailto:support@riteclass.com?Subject=Last%20Page%20Support">
                <RaisedButton className="marg-left" label="Get In Touch" primary={true} />
                </a>
              </span>
            </Col>
          </Row>
        </Grid>

      </div>
    )
  }
}

const mapStateToProps = createSelector(
  getConfirmedGroup,
  getHousingResult,
  getAuth,
  (confirmedGroup, housingResult, currentUser) => ({
    confirmedGroup,
    housingResult,
    currentUser
  })
)

const mapDispatchToProps = Object.assign(
  {},
  confirmedGroupActions,
  housingResultActions
)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HousingResults)



// WEBPACK FOOTER //
// ./src/views/pages/housing-results/index.js